var lib_core = require("lib-core");
var IpcPadGeneratorInteractionModel = require('./ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var IpcSmdPadGeneratorWithThermalPadInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(IpcSmdPadGeneratorWithThermalPadInteractionModel, IpcPadGeneratorInteractionModel);
IpcSmdPadGeneratorWithThermalPadInteractionModel.$class = 'IpcSmdPadGeneratorWithThermalPadInteractionModel';
module.exports = IpcSmdPadGeneratorWithThermalPadInteractionModel;

IpcSmdPadGeneratorWithThermalPadInteractionModel.prototype.initialize = function() {
    var self = this;
    IpcPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.hasThermalPad = this.shadow("hasThermalPad",
        function() {
            return self.data.hasThermalPad();
        },
        function(value) {
            var status = self.data.hasThermalPad(value);
            self.updateNameList();
            return status;
        },
        [
            self.data.hasThermalPad
        ]
    );

    this.showThermalPadSettings = this.shadow("showThermalPadSettings",
        function() {
            return self.data.hasThermalPad();
        },
        null,
        [
            self.data.hasThermalPad
        ]
    );

    this.thermalPadLength = this.shadow("thermalPadLength",
        function() {
            return self.data.thermalPadLength() / self.getUnitFactor();
        },
        function(value) {
            return self.data.thermalPadLength(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.thermalPadLength, this.userSettingsModel.distanceUnit
        ]
    );

    this.thermalPadWidth = this.shadow("thermalPadWidth",
        function() {
            return self.data.thermalPadWidth() / self.getUnitFactor();
        },
        function(value) {
            return self.data.thermalPadWidth(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.thermalPadWidth, this.userSettingsModel.distanceUnit
        ]
    );

    this.thermalPadSolderPasteOverride = this.shadow("thermalPadSolderPasteOverride",
        function() {
            return self.data.thermalPadSolderPasteOverride();
        },
        function(value) {
            return self.data.thermalPadSolderPasteOverride(value);
        },
        [
            self.data.thermalPadSolderPasteOverride
        ]
    );

    this.showThermalPadSolderPasteSettings = this.shadow("showThermalPadSolderPasteSettings",
        function() {
            return self.showThermalPadSettings() && self.data.thermalPadSolderPasteOverride();
        },
        null,
        [
            self.data.thermalPadSolderPasteOverride, self.showThermalPadSettings
        ]
    );

    this.thermalPadSolderPasteStencilRowCount = this.shadow("thermalPadSolderPasteStencilRowCount",
        function() {
            return self.data.thermalPadSolderPasteStencilRowCount();
        },
        function(value) {
            if(value <= 0) return false;
            return self.data.thermalPadSolderPasteStencilRowCount(value);
        },
        [
            self.data.thermalPadSolderPasteStencilRowCount
        ]
    );

    this.thermalPadSolderPasteStencilColCount = this.shadow("thermalPadSolderPasteStencilColCount",
        function() {
            return self.data.thermalPadSolderPasteStencilColCount();
        },
        function(value) {
            if(value <= 0) return false;
            return self.data.thermalPadSolderPasteStencilColCount(value);
        },
        [
            self.data.thermalPadSolderPasteStencilColCount
        ]
    );

    this.thermalPadSolderPasteStencilApertureLength = this.shadow("thermalPadSolderPasteStencilApertureLength",
        function() {
            return self.data.thermalPadSolderPasteStencilApertureLength() / self.getUnitFactor();
        },
        function(value) {
            if(value <= 0) return false;
            return self.data.thermalPadSolderPasteStencilApertureLength(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.thermalPadSolderPasteStencilApertureLength, self.userSettingsModel.distanceUnit
        ]
    );

    this.thermalPadSolderPasteStencilApertureWidth = this.shadow("thermalPadSolderPasteStencilApertureWidth",
        function() {
            return self.data.thermalPadSolderPasteStencilApertureWidth() / self.getUnitFactor();
        },
        function(value) {
            if(value <= 0) return false;
            return self.data.thermalPadSolderPasteStencilApertureWidth(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.thermalPadSolderPasteStencilApertureWidth, self.userSettingsModel.distanceUnit
        ]
    );

    this.thermalPadSolderPasteStencilApertureGapX = this.shadow("thermalPadSolderPasteStencilApertureGapX",
        function() {
            return self.data.thermalPadSolderPasteStencilApertureGapX() / self.getUnitFactor();
        },
        function(value) {
            return self.data.thermalPadSolderPasteStencilApertureGapX(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.thermalPadSolderPasteStencilApertureGapX, self.userSettingsModel.distanceUnit
        ]
    );

    this.thermalPadSolderPasteStencilApertureGapY = this.shadow("thermalPadSolderPasteStencilApertureGapY",
        function() {
            return self.data.thermalPadSolderPasteStencilApertureGapY() / self.getUnitFactor();
        },
        function(value) {
            return self.data.thermalPadSolderPasteStencilApertureGapY(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.thermalPadSolderPasteStencilApertureGapY, self.userSettingsModel.distanceUnit
        ]
    );

    this.thermalPadSolderPasteAreaCoverage = this.shadow("thermalPadSolderPasteAreaCoverage",
        function() {
            var totalArea = self.data.thermalPadLength() * self.data.thermalPadWidth();
            var totalApertureArea = self.data.thermalPadSolderPasteStencilRowCount()
                                    * self.data.thermalPadSolderPasteStencilColCount()
                                    * self.data.thermalPadSolderPasteStencilApertureLength()
                                    * self.data.thermalPadSolderPasteStencilApertureWidth();

            return 100 * (totalApertureArea / totalArea).toFixed(2);
        },
        function(value) {
            if(value <= 0) return false;

            //create aperture size and gap automatically without changing grid size when area coverage is updated 
            var totalArea = self.data.thermalPadLength() * self.data.thermalPadWidth();
            var x = value * totalArea / 100;
            var y = self.data.thermalPadLength() / self.data.thermalPadWidth();

            var a = Math.sqrt(x * y);
            var b = Math.sqrt(x / y);

            var apertureX = a / self.data.thermalPadSolderPasteStencilColCount();
            var apertureY = b / self.data.thermalPadSolderPasteStencilRowCount();

            //distrubute gap around apertures uniformly along each direction
            var gapX = Math.abs(self.data.thermalPadLength() - a) / (self.data.thermalPadSolderPasteStencilColCount() + 1);
            var gapY = Math.abs(self.data.thermalPadWidth() - b) / (self.data.thermalPadSolderPasteStencilRowCount() + 1);

            self.data.thermalPadSolderPasteStencilApertureLength(apertureX);
            self.data.thermalPadSolderPasteStencilApertureWidth(apertureY);
            self.data.thermalPadSolderPasteStencilApertureGapX(gapX);
            self.data.thermalPadSolderPasteStencilApertureGapY(gapY);

            return true;
        },
        [
            self.data.thermalPadSolderPasteStencilRowCount,
            self.data.thermalPadSolderPasteStencilColCount,
            self.data.thermalPadSolderPasteStencilApertureLength,
            self.data.thermalPadSolderPasteStencilApertureWidth,
            self.data.thermalPadLength,
            self.data.thermalPadWidth
        ]
    );
};

IpcSmdPadGeneratorWithThermalPadInteractionModel.prototype.getInspectorElementForEnablingThermalPad = function() {
    return [PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('thermalPad', 'Thermal Pad'), this.hasThermalPad)];
};

IpcSmdPadGeneratorWithThermalPadInteractionModel.prototype.getInspectorElementForThermalPadSize = function() {
    //length and width interchanged in tooltip to be aligned with body size tooltip (D: Length, E: Width)
    var thermalPadLength = PackageGeneratorInspectorConfig.getValueFixedUnit('E2', this.LCLZ('thermalPadWidth', 'Thermal Pad Width'), this.thermalPadLength, this.userSettingsModel.distanceUnit, this.showThermalPadSettings);
    var thermalPadWidth = PackageGeneratorInspectorConfig.getValueFixedUnit('D2', this.LCLZ('thermalPadLength', 'Thermal Pad Length'), this.thermalPadWidth, this.userSettingsModel.distanceUnit, this.showThermalPadSettings);

    return [thermalPadWidth, thermalPadLength];
};

IpcSmdPadGeneratorWithThermalPadInteractionModel.prototype.getInspectorElementForThermalPadSolderPasteOverride = function() {
    var visibilityMember = null;

    if(this.showFootprintParams()) {
        visibilityMember = this.showThermalPadSettings;
    } else {
        visibilityMember = this.showFootprintParams;
    }

    return [PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('customSolderPaste', 'Custom Solder Paste'), this.thermalPadSolderPasteOverride, visibilityMember)];
};

IpcSmdPadGeneratorWithThermalPadInteractionModel.prototype.getInspectorElementForThermalPadSolderPastePattern = function() {
    var visibilityMember = null;

    if(this.showFootprintParams()) {
        visibilityMember = this.showThermalPadSolderPasteSettings;
    } else {
        visibilityMember = this.showFootprintParams;
    }

    //length and width interchanged in tooltip to be aligned with body size tooltip (D: Length, E: Width)
    var spPatternImage = PackageGeneratorInspectorConfig.getImage(IpcImages.solderPastePattern, visibilityMember);
    var spStencilRowCount = PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#Rows', '# Rows'), this.thermalPadSolderPasteStencilRowCount, visibilityMember);
    var spStencilColCount = PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#Cols', '# Cols'), this.thermalPadSolderPasteStencilColCount, visibilityMember);
    var spStencilApertureLength = PackageGeneratorInspectorConfig.getValueFixedUnit('e3', this.LCLZ('apertureWidth', 'Aperture Width'), this.thermalPadSolderPasteStencilApertureLength, this.userSettingsModel.distanceUnit, visibilityMember);
    var spStencilApertureWidth = PackageGeneratorInspectorConfig.getValueFixedUnit('d3', this.LCLZ('apertureLength', 'Aperture Length'), this.thermalPadSolderPasteStencilApertureWidth, this.userSettingsModel.distanceUnit, visibilityMember);
    var spStencilApertureGapY = PackageGeneratorInspectorConfig.getValueFixedUnit('g1', this.LCLZ('apertureGap1', 'Aperture Gap 1'), this.thermalPadSolderPasteStencilApertureGapY, this.userSettingsModel.distanceUnit, visibilityMember);
    var spStencilApertureGapX = PackageGeneratorInspectorConfig.getValueFixedUnit('g2', this.LCLZ('apertureGap2', 'Aperture Gap 2'), this.thermalPadSolderPasteStencilApertureGapX, this.userSettingsModel.distanceUnit, visibilityMember);
    
    return [spPatternImage, spStencilRowCount, spStencilColCount, spStencilApertureWidth, spStencilApertureLength, spStencilApertureGapY, spStencilApertureGapX];
};

IpcSmdPadGeneratorWithThermalPadInteractionModel.prototype.getInspectorElementForThermalPadSolderPasteCoverageArea = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit(this.LCLZ('pasteCoverage', 'Paste Coverage'), '', this.thermalPadSolderPasteAreaCoverage, '%', (this.showFootprintParams() ? this.showThermalPadSolderPasteSettings : this.showFootprintParams))];
};

IpcSmdPadGeneratorWithThermalPadInteractionModel.prototype.getInspectorElementsForThermalPadSettings = function() {
    var imElements = [];

    imElements = imElements.concat(this.getInspectorElementForEnablingThermalPad());
    imElements = imElements.concat(this.getInspectorElementForThermalPadSize());
    imElements = imElements.concat(this.getInspectorElementForThermalPadSolderPasteOverride());
    imElements = imElements.concat(this.getInspectorElementForThermalPadSolderPastePattern());
    imElements = imElements.concat(this.getInspectorElementForThermalPadSolderPasteCoverageArea());

    return imElements;
};